<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="container m-t-rel" *ngIf="useCase">
  <div class="columns">
    <div class="column is-8 pt-0">
      <h1 class="title is-2 m-t-0 m-b-0">
        {{ useCase.name }}
      </h1>

      <div class="flex space-between align-center">
        <p class="small-meta">
          <span class="m-r-xs" *ngIf="useCase">{{
            useCase.publishedAt | date
          }}</span>
        </p>
        <div class="flex align-center space-between post-meta-sharing-box">
          <div>
            <app-social-share
              [title]="useCase.name"
              [darkTheme]="false"
            ></app-social-share>
          </div>
        </div>
      </div>
      <div
        class="block block--link has-background-white-ter is-size-6 m-b-gutter mt-2"
        *ngIf="useCase.tool"
      >
        <div class="py-5">
          <ng-container>
            <strong class="is-bold m-r-md">Tool concerned:</strong>
            <a [routerLink]="['/catalogue', 'tools', useCase.tool.slug]">{{
              useCase.tool.name
            }}</a>
          </ng-container>
        </div>
      </div>

      <figure class="media-left" *ngIf="useCase.image">
        <p class="image">
          <img
            *ngIf="useCase.image"
            [src]="storagePath + useCase.image + '-landscape.jpg'"
            [alt]="useCase.name"
          />
        </p>
      </figure>
      <div class="full-width mb-6" [innerHTML]="useCase.content"></div>

      <h2 class="title is-2" *ngIf="useCase.benefitsParagraph">
        Benefits of using the tool in this use case
      </h2>

      <div
        class="full-width mb-6"
        [innerHTML]="useCase.benefitsParagraph"
      ></div>

      <h2 class="title is-2" *ngIf="useCase.shortcomings">
        Shortcomings of using the tool in this use case
      </h2>
      <div
        class="full-width mb-6"
        [innerHTML]="useCase.shortcomings"
        *ngIf="useCase.shortcomings"
      ></div>

      <h2 class="title is-2" *ngIf="useCase.learnings">
        Learnings or advice for using the tool in a similar context
      </h2>
      <div
        class="full-width mb-6"
        [innerHTML]="useCase.learnings"
        *ngIf="useCase.learnings"
      ></div>

      <h2 class="title is-2" *ngIf="useCase.comparison">
        Comparison with other tools
      </h2>
      <div
        class="full-width mb-6"
        [innerHTML]="useCase.comparison"
        *ngIf="useCase.comparison"
      ></div>

      <p class="has-text-right">
        <a
          (click)="showReportUseCaseModal = true"
          (keydown)="showReportUseCaseModal = true"
          tabindex="0"
          class="flag-link has-text-primary is-size-6 no-deco"
        >
          <i class="icon icon-Assignedtomyself1 mr-2"></i>
          <span>Modify this use case</span>
        </a>
      </p>
    </div>
    <!-- Taxonomy sidebar -->
    <div class="column is-4 pb-0">
      <div class="card bg-white taxonomy-relation-list">
        <h3 class="is-size-5 mt-6 mb-5">About the use case</h3>
        <div class="is-size-7">
          <div class="block block--link">
            <p class="my-0">
              You can click on the links to see the associated use cases
            </p>
          </div>
          <ng-container *ngFor="let taxonomy of sidebarTaxonomies">
            <ng-container *ngIf="useCase[taxonomy.propName]?.length">
              <hr class="has-background-white-bis" />
              <div
                class="is-flex is-align-items-flex-start is-justify-content-center"
              >
                <p class="my-0 is-bold">{{ taxonomy.label }}:</p>
                <ul class="my-0 ml-0 no-lst">
                  <li *ngFor="let item of useCase[taxonomy.propName]">
                    <a
                      *ngIf="taxonomy.queryParamName"
                      (click)="
                        goToFilteredList(taxonomy.queryParamName, item.id)
                      "
                      (keydown)="
                        goToFilteredList(taxonomy.queryParamName, item.id)
                      "
                      tabindex="0"
                    >
                      {{ item.name }}
                    </a>
                  </li>
                </ul>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Report tool modal -->
<app-flag-modal
  *ngIf="showReportUseCaseModal"
  [resourceId]="useCase.id"
  [resourceType]="ResourceSlug.ToolUseCases"
  (modalClosed)="showReportUseCaseModal = false"
></app-flag-modal>
